module.exports = __webpack_public_path__ + "8784eeb2aec6c76d87d5ef2dbf71c852.svg";